import { Shell } from "../../../components/ops/Shell";
import { useAuth } from "../../../context/AuthContext";
import { staffNavItems } from "../staffNav";

export function StaffLayout() {
  const { user, signOut } = useAuth();

  return (
    <Shell
      navItems={staffNavItems}
      brandTitle="Formula Soccer"
      brandSubtitle="Staff Portal"
      eyebrow="Staff Portal"
      user={user}
      onSignOut={signOut}
      theme="staff"
    />
  );
}
